/**
 * Создает редюсер
 * @param {Object} handlers - Объект, где ключи это action.type, а значение это фукнция, которая изменяет стор
 * @param {Object} initialState - Начальный store state
 * @returns {function(*=, *=)} - Функция редюсер для redux
 */
const buildReducer = (handlers = {}, initialState = {}) => (
  state = initialState,
  action
) => {
  const handler = handlers && handlers[action.type];
  return handler
    ? handler(state, action && action.payload, action && action.meta)
    : state;
};

export default buildReducer;
